<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title"><b>CONTENTS</b></p>
<p class="tocfm"><a href="#/xhtml/05_Abbreviations">Abbreviations</a></p>
<p class="tocfm"><a href="#/xhtml/06_Preface">Preface</a></p>
<p class="tocfm"><a href="#/xhtml/07_Introduction">Introduction</a></p>
<p class="toc1"><span href="#/xhtml/08_Bradford" title="Link target outside of Sample">BRADFORD</span></p>
<p class="toc1"><span href="#/xhtml/09_Gateshead" title="Link target outside of Sample">GATESHEAD</span></p>
<p class="toc1"><span href="#/xhtml/10_Hull" title="Link target outside of Sample">HULL</span></p>
<p class="toc1"><span href="#/xhtml/11_Leeds" title="Link target outside of Sample">LEEDS</span></p>
<p class="toc1"><span href="#/xhtml/12_Newcastle" title="Link target outside of Sample">NEWCASTLE</span></p>
<p class="toc1"><span href="#/xhtml/13_Rotherham" title="Link target outside of Sample">ROTHERHAM</span></p>
<p class="toc1"><span href="#/xhtml/14_Sheffield" title="Link target outside of Sample">SHEFFIELD</span></p>
<p class="toc1"><span href="#/xhtml/15_South_Shields" title="Link target outside of Sample">SOUTH SHIELDS</span></p>
<p class="toc1"><span href="#/xhtml/16_South_Yorkshire_Supertram" title="Link target outside of Sample">SOUTH YORKSHIRE SUPERTRAM</span></p>
<p class="toc1"><span href="#/xhtml/17_Sunderland" title="Link target outside of Sample">SUNDERLAND</span></p>
<p class="toc1"><span href="#/xhtml/18_Tyne_Wear_Metro" title="Link target outside of Sample">TYNE &amp; WEAR METRO</span></p>
<p class="toc1"><span href="#/xhtml/19_Preservation" title="Link target outside of Sample">PRESERVATION</span></p>
<p class="tocfm"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?2370102c